import eth from "../images/eth.png";
import arb from "../images/arbitrum.png";
import { SupportedChainId } from "./constant/chains";
import { toHex } from "./api/common";

export const networks: { [key: number]: { [key: string]: any } } = {
  // [UnsupportedChainId.MAINNET]: {
  //   label: "Ethereum",
  //   icon: eth,
  //   hex: toHex(UnsupportedChainId.MAINNET),
  // },
  [SupportedChainId.GOERLI]: {
    label: "Goerli",
    icon: eth,
    hex: toHex(SupportedChainId.GOERLI),
  },
  [SupportedChainId.ARBITRUM_ONE]: {
    label: "Arbitrum",
    icon: arb,
    hex: toHex(SupportedChainId.ARBITRUM_ONE),
  },
};

export const networkParams = {
  // [UnsupportedChainId.MAINNET]: {
  //   chainId: toHex(UnsupportedChainId.MAINNET),
  //   rpcUrls: ["https://mainnet.infura.io/v3/"],
  //   chainName: "Mainnet",
  //   nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
  //   blockExplorerUrl: ["https://etherscan.io"],
  //   iconUrls: [eth],
  // },
  [SupportedChainId.GOERLI]: {
    chainId: toHex(SupportedChainId.GOERLI),
    rpcUrls: ["https://goerli.infura.io/v3/"],
    chainName: "Görli",
    nativeCurrency: { name: "ETH", decimals: 18, symbol: "ETH" },
    blockExplorerUrl: ["https://goerli.etherscan.io/"],
    iconUrls: [eth],
  },
  [SupportedChainId.ARBITRUM_ONE]: {
    chainId: toHex(SupportedChainId.ARBITRUM_ONE),
    rpcUrls: ["https://arb1.arbitrum.io/rpc"],
    chainName: "Arbitrum One",
    nativeCurrency: { name: "AETH", decimals: 18, symbol: "AETH" },
    blockExplorerUrl: ["https://arbiscan.io"],
    iconUrls: [arb],
  },
};
